import { render } from "./RoleShowComponent.vue?vue&type=template&id=7011db42"
import script from "./RoleShowComponent.vue?vue&type=script&lang=js"
export * from "./RoleShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Role/RoleShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7011db42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7011db42', __exports__)) {
    api.reload('7011db42', __exports__)
  }
  
  module.hot.accept("./RoleShowComponent.vue?vue&type=template&id=7011db42", () => {
    api.rerender('7011db42', render)
  })

}


export default __exports__